import React, { useMemo, useState } from 'react';
import { Card, CardBody, Col, Container, Button } from 'reactstrap';
import DataTable, { TableColumn } from 'react-data-table-component';
import { useNavigate, Link } from 'react-router-dom';
import { Modulo } from '../../../Types/Tables.type';
import { useIteamResource } from '../../../hook/ShowTable/generic';
import FilterComponent from '../../../Components/Tables/DataTables/Common/FilterComponent';
import Loader from '../../../Components/Widgets/Loader/generic';
import { Btn } from '../../../AbstractElements';


export interface Lingua {
    ID: string | number;
    nome: string | number | null;
    classe: string;
    codice: string;
    ordine: number;
    abilitato: number
}


export default function Index() {
  const [filterText, setFilterText] = useState('');
  const { data: rows, loading } = useIteamResource<Lingua[]>('/languages');
  const navigate = useNavigate();




  const filteredRows: Lingua[] = useMemo(() => {
    const list = rows ?? [];
    if (!filterText) return list;
    const q = filterText.toString().toLowerCase();
    return list.filter((r) => {
      const nome = (r.nome ?? '').toString().toLowerCase();
      const codice = (r.codice ?? '').toString().toLowerCase();
      return nome.includes(q) || codice.includes(q);
    });
  }, [rows, filterText]);


  const handleDelete = (row: Lingua) => {
    console.log('Delete', row);
  };

  // Colonne
  const columns: TableColumn<Lingua>[] = useMemo(() => [
    {
      name: 'Nome',
      cell: (row) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ display: 'inline-block'}} />
          {row.nome}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Codice',
      selector: (row) => row.codice,
      sortable: true,
      width: '300px',
    },
    {
      name: 'Abilitato',
      selector: (row) => row.abilitato,
      sortable: true,
      right: true,
      width: '120px',
    },
    {
      name: 'Azioni',
      cell: (row) => {
        const slug = encodeURIComponent(String(row.ID));
        return (
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              size="sm"
              color="primary"
              tag={Link as any}
              to={`/admin/language/${slug}`}
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
            >
              Modifica
            </Button>

            <Button
              size="sm"
              color="danger"
              onClick={(e) => { e.stopPropagation(); handleDelete(row); }}
            >
              Elimina
            </Button>
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '280px',
    },
  ], []);

  return (
    <Container fluid className="pt-2">
      <Col xl={12} className="mb-lg-3 d-flex justify-content-end">
        <Link to="/admin/language/new">
          <Btn className="px-4" color="primary" type="button">
            NUOVO
          </Btn>
        </Link>
      </Col>
      <Col sm={12}>
        <Card>
          <CardBody>
            <FilterComponent
              onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
              filterText={filterText}
            />
            <div className="table-responsive">
              <DataTable<Lingua>
                data={filteredRows}
                columns={columns}
                progressPending={loading}
                progressComponent={<Loader />}
                pagination
                striped
                highlightOnHover
                className="display"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Container>
  );
}
